<template>
  <div class="login">
    <img alt="" class="welcomeLogin" :src="welcomeLogin" />
    <div class="phoneNo" v-if="phoneFlag">
      <span>+86</span>
      <input type="tel" pattern="[0-9]*" placeholder="请输入手机号" :disabled="$route.query.type === 'timeMachine'" v-model="phoneNum" oninput="if(value.length>11) value=value.slice(0,11)" />
    </div>
    <div class="originalPhone" v-if="!phoneFlag">{{phoneNum | filterPhNum }}</div>
    <div class="verificationCode">
      <input type="tel" pattern="[0-9]*" placeholder="请输入验证码" v-model="captchaVal" maxlength="6" />
      <button @click="getGenImg" :disabled="disabled">{{ btnText }}</button>
    </div>
    <div class="agreement" @click="agreementCheck">
      <van-checkbox
        v-model="agreementChecked"
        style="
          position: absolute;
          top: 50%;
          margin-top: -0.04rem;
          height: 0.14rem;
          width: 0.14rem;
        "
        icon-size="0.12rem"
        checked-color="#5f2689"
      ></van-checkbox>
      <p>
        我已阅读并同意
        <span @click.stop="goRead">《紫金保险线上平台用户服务协议》</span>
        <span @click.stop="goRead('scret')">、《隐私权政策》</span>
      </p>
    </div>
    <button class="button_area" :disabled="stop" :style="{background: stop? '#999': '#5f2689'}" @click="goHome">登录</button>
    <div class="tip" v-if="hidshow">
      <p>
        温馨提示：如有疑问，您可以致电我司客户服务电话<a style="color: rgba(242, 150, 0, 1)" href="tel:95312">95312</a>
      </p>
    </div>
    <van-dialog
      class="imgCodeCon"
      v-model="IsImgCode"
      title="请输入图形验证码"
      confirm-button-color="#5E2589"
      :showConfirmButton="false"
      :closeOnClickOverlay = "true"
      width="80%"
    >
      <div class="firstDiaCode">
        <van-field v-model="genObj.imgCode" placeholder="请输入" maxlength="4" style="align-items: end;"/>
        <img style="width: 1.44rem;height: .54rem;padding-bottom: .05rem; " :src="genObj.captchaImg" @click="getGenImgCode" alt="">
      </div>
      <div class="sureBtn" @click="popSubmit">
        确定
      </div>
    </van-dialog>
    <Loading :switchs="switchs" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading'
import checkFormat from '@/utils/checkFormat.js'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      code: '', // 微信的code
      phoneNum: '',
      captchaVal: '', // 验证码
      captchaId: '', // 登录验证码ID
      agreementChecked: false,
      interval: undefined, // 定时器标识
      disabled: false,
      totalCount: 0, // 60s计时
      userType: '', // 用户标识
      // openId: "", //微信openId
      // unionId: "", //微信unionId
      btnText: '获取验证码',
      welcomeLogin: api.imgAllUrl + '/welcomeLogin.png',
      showHeight: document.documentElement.clientHeight,
      docmHeight: document.documentElement.clientHeight,
      hidshow: true,
      Directflag: '',
      comName: '', // 机构名
      stop: false, // 登录后禁止再次点击登录
      phoneFlag: true,
      switchs: false,
      loginToken: "", // 登录接口返回的token
      IsImgCode: false, //图片验证码弹框
      genObj:{
        imgCode: '',
        captchaId: '',
        captchaImg:''
      } //图形验证码后端返回参数
    }
  },
  filters: {
    filterPhNum: function (value) {
      return value.replace(value.substr(3, 4), "****")
    },
  },
  watch: {
    showHeight(val) {
      const that = this
      that.hidshow = true
      if (that.docmHeight > val) {
        that.hidshow = false
      } else {
        that.hidshow = true
      }
    }
  },
  created() {
    document.title = '摩托车险登录'
    // this.phoneNo = "18362983759";
    this.phoneNo = this.$route.query.pNum
    localStorage.setItem('setToken', '')
    localStorage.setItem('cInfo', '')
  },
  activated() {
    this.$store.commit('set_showStep', false)
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        this.showHeight = window.fullHeight
        // console.log("this.showHeight",this.showHeight);
      })()
    }
    const comName = localStorage.getItem('setMotorAreaName')
    this.comName = comName
    localStorage.setItem('setMotorCode', `${this.comName}Code`)
    if (comName === 'SHAAN_XI') {
      this.$http.get(`${api.buryPoint}?locationPointId=${api.pointOBj.loginPoint}`).then(res => {
        if (res.data.code === 200) {
          console.log('登录埋点成功')
        }
      })
    }
  },
  components: {
    Loading: Loading,
    [Dialog.Component.name]: Dialog.Component
  },
  methods: {
    // 获取验证码
    sendCheckCode() {
      // this.captchaId = '495484'
      this.switchs = true
      const params = {
        "systemCode": "ZSBAPP",
        "expirationType": "SMS",
        "imgCaptchaCode": this.genObj.imgCode,
        "imgCaptchaId":this.genObj.captchaId,
        "phone": this.phoneNum
      }
      this.$http
        .post(api.genSmsCaptcha, params)
        .then((res) => {
          this.switchs = false
          // console.log(res);
          if (res.data.rtnCode === '0000') {
            this.IsImgCode = false
            this.captchaId = res.data.captchaId
            // 按钮60秒倒计时
            this.disabled = true
            let totalCount = 60
            const that = this
            this.interval = setInterval(() => {
              if (totalCount <= 0) {
                clearInterval(that.interval)
                that.disabled = false
                that.btnText = '获取验证码'
                return
              } else {
                that.btnText = `${totalCount}s`
                totalCount--
              }
            }, 1000)
          } else {
            Toast({
              message: res.data.rtnMsg || "系统异常",
              position: "top",
              duration: 1000,
            });
          }
        })
        .catch((error) => {
          this.switchs = false
          Toast({
              message: error || "系统异常",
              position: "top",
              duration: 1000,
            });
        })
    },
    agreementCheck() {
      this.agreementChecked = !this.agreementChecked
    },
    goRead(str) {
      // 阅读协议
      str === 'scret' ?  this.$router.push({ name: 'Agreement', query: { isScret: '1'}}) : this.$router.push({ name: 'Agreement'})
    },
    async goHome() {
      if (!checkFormat.checkPhone(this.phoneNum)) {
        Toast({
          message: '您输入的手机号有误，请重新输入',
          position: 'top',
          duration: 1000
        })
        return false
      } else if (this.captchaVal === '') {
        Toast({
          message: '请填写验证码',
          position: 'top',
          duration: 1000
        })
        return false
      } else if (!this.agreementChecked) {
        Toast({
          message: '请阅读并确认用户服务协议',
          position: 'top',
          duration: 1000
        })
        return false
      } else if (!/^(\d){6}$/.test(this.captchaVal)) {
        Toast({
          message: '验证码错误',
          position: 'top',
          duration: 1000
        })
        return false
      } else if (this.captchaId === '' || this.captchaId == null) {
        Toast({
          message: '验证码有误，请重新获取验证码',
          position: 'top',
          duration: 1500
        })
        return false
      }
      this.stop = true
      // localStorage.setItem('setToken', '73356ABEB4F5937B348D3FB2AA48172B')

      const params = {
        captchaId: this.captchaId, // 验证码ID
        captchaVal: this.captchaVal, // 验证码
        phoneNumber: this.phoneNum,
        code: ''
      }
      this.switchs = true
      const res = await this.$http.post(api.newLoginForOfficial, params)
      console.log(res.data, 'newLoginForOfficial')
      // let res = {}
      // res.data = {rtnCode:"9905",rtnMsg:"未实名认证",token:null,userType:null,accountType:null,certificationStatus:"1",register:"0",customerId:null}
      localStorage.setItem('setToken', res.data.token)
      if (res.data.rtnCode === '0000') {
        this.switchs = false
        // console.log(res.data, 'eididididiidid')
        if (res.data.certificationStatus === '0') { // 已经实名认证
          // console.log(res.data.token, '获取的token')
          console.log(process.env.ENV_CONFIG, 'ENV_CONFIGit')
          const { data } = await this.$http.get(api.getOfficialWXAccount)
          if (data.rtnCode === '0000') {
            const identityNum = process.env.ENV_CONFIG === 'prod' ? data.identityNum : data.certificateList[0].certificateNumber
            const sex = parseInt(identityNum.substr(16, 1)) % 2 === 1 ? '男' : '女'
            const obj = {
              identifyNum: identityNum,
              name: data.userName,
              phoneNumber: data.phoneNumber,
              gender: sex
            }
            localStorage.setItem('cInfo', JSON.stringify(obj))
            this.$router.push({ name: 'BaseInfo' })
          } else {
            this.$toast({
              message: data.rtnMsg,
              position: 'top'
            })
            return
          }
          await this.$http.get(api.motorPolicy+`/${this.comName}`).then(resTwo=>{
            console.log(resTwo, 'motorPolicy')
            if (resTwo.data.rtnCode==='0000') {
              if (resTwo.data.data==null||resTwo.data.data.policyNo==null||resTwo.data.data.policyNo==undefined||resTwo.data.data.policyNo=='') {
                this.$router.push({name:'BaseInfo'})
              } else {
                this.$router.push({name:'InsuredSuccess',query:{
                  licenseNo:resTwo.data.data.liceseNo,
                  policyNo:resTwo.data.data.policyNo,
                  areaName:this.comName
                }})
              }
            } else {
              Toast(resTwo.data.rtnMsg)
            }

          })
        } else {
          // 是注册用户
          if (res.data.register === '0') {
            // 转入注册用户页
            this.$router.push({
              name: 'RegisteredUsers',
              query: {
                pNum: this.phoneNum,
                type: '',
                captchaId: this.captchaId, // 验证码ID
                captchaVal: this.captchaVal // 验证码
              }
            })
          } else {
            // 完善个人信息页
            this.$router.push({
              name: 'PerfectPersonalInfo',
              query: {
                pNum: this.phoneNum,
                type: '',
                captchaId: this.captchaId, // 验证码ID
                captchaVal: this.captchaVal // 验证码
              }
            })
          }
        }
      } else if (res.data.rtnCode === '9943') {
        this.switchs = false
        // 完善个人信息页
        this.$router.push({
          name: 'PerfectPersonalInfo',
          query: {
            pNum: this.phoneNum,
            type: '',
            captchaId: this.captchaId, // 验证码ID
            captchaVal: this.captchaVal // 验证码
          }
        })
      } else if (res.data.rtnCode === '9905') {
        this.switchs = false
        if (res.data.register === '0') {
          // 转入注册用户页
          this.$router.push({
            name: 'RegisteredUsers',
            query: {
              pNum: this.phoneNum,
              type: '',
              captchaId: this.captchaId, // 验证码ID
              captchaVal: this.captchaVal // 验证码
            }
          })
        } else {
          // 完善个人信息页
          this.$router.push({
            name: 'PerfectPersonalInfo',
            query: {
              pNum: this.phoneNum,
              type: '',
              captchaId: this.captchaId, // 验证码ID
              captchaVal: this.captchaVal // 验证码
            }
          })
        }
      } else {
        this.switchs = false
        this.stop = false
        this.$toast({
          message: res.data.rtnMsg,
          position: 'top'
        })
      }
    },
    popSubmit() { //确认图片验证码
      console.log(checkFormat.isEmpty(this.genObj.imgCode))
      if (!checkFormat.isEmpty(this.genObj.imgCode)) {
        this.sendCheckCode()
      } else {
        this.$toast("请填写图形验证码");
      }
    },
    getGenImg() {
      if (!checkFormat.checkPhone(this.phoneNum)) {
        Toast({
          message: '您输入的手机号有误，请重新输入',
          position: 'top',
          duration: 1000
        })
        return false
      }
      console.log('获取验证码')
      this.IsImgCode = true
      this.getGenImgCode()
    },
    getGenImgCode() {
      this.switchs = true
      this.$http
      .post(api.genImg + `?expirationType=SMS`)
      .then(res=>{
        this.switchs = false
        console.log(res, '----')
          if (res.data.resultCode && !checkFormat.isEmpty(res.data.resultCode)) {
            this.IsImgCode = false
            Toast({
              message: 'captcha/genImg'+ res.data.resultCode + res.data.resultMsg,
              position: "top",
              duration: 1000,
            });
          } else {
            this.genObj = res.data
          }
      })
      .catch(error => {
        this.IsImgCode = false
        this.switchs = false
        Toast({
            message: error || "captcha/genImg系统异常",
            position: "top",
            duration: 1000,
          });
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.12rem;
  font-family: "PingFang SC", "Microsoft YaHei", Helvetica, Tahoma, Arial,
    "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  background: #f9f9f9;
  /*修改input提示文字*/
  input::-webkit-input-placeholder {
    color: #999999;
    font-size: 0.16rem;
  }
  input::-moz-placeholder {
    color: #999999;
    font-size: 0.16rem;
  }
  input::-ms-input-placeholder {
    color: #999999;
    font-size: 0.16rem;
  }
  .welcomeLogin {
    height: 1.14rem;
    width: 100%;
  }
  .phoneNo {
    display: flex;
    align-items: center;
    width: 90%;
    height: 0.56rem;
    font-size: 0.16rem;
    background-color: #f3f0f9;
    border-radius: 0.05rem;
    span {
      margin: 0 0.2rem;
      width: 0.3rem;
      height: 0.22rem;
      color: #2f2f4a;
      background-color: #f3f0f9;
    }
    input {
      width: 1.8rem;
      height: 0.3rem;
      background-color: #f3f0f9;
      border: none;
    }
  }
  .originalPhone {
    width: 90%;
    height: 0.56rem;
    line-height: 0.56rem;
    font-size: 0.2rem;
    font-weight: bold;
  }
  .verificationCode {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.16rem;
    width: 90%;
    height: 0.56rem;
    background-color: #f3f0f9;
    border-radius: 0.05rem;
    input {
      margin-left: 0.2rem;
      width: 1.2rem;
      height: 0.3rem;
      font-size: 0.16rem;
      background-color: #f3f0f9;
      border: none;
    }
    button {
      margin-right: 0.1rem;
      width: 1rem;
      height: 0.27rem;
      color: #5f2689;
      background-color: #f3f0f9;
      border: 1px solid #5f2689;
      border-radius: 0.05rem;
    }
  }
  .agreement {
    width: 90%;
    height: 0.35rem;
    color: #999999;
    position: relative;
    p {
      display: inline-block;
      margin-left: 0.2rem;
      margin-top: 0.12rem;
      span {
        color: #592581;
      }
    }
  }
  .button_area {
    margin-top: 0.3rem;
    width: 90%;
    height: 0.5rem;
    background: #5f2689;
    border-radius: 0.5rem;
    color: #ffffff;
    font-size: 0.16rem;
    text-align: center;
    line-height: 0.5rem;
    border: none;
  }
  .tip {
    margin-top: auto;
    margin-bottom: 0.12rem;
    color: #999999;
    text-align: center;
    p {
      margin: 0;
      span {
        margin-left: 3px;
        color: #ff9443;
      }
    }
  }
  .imgCodeCon {
    width: 80%;
    padding:0 .2rem;
    box-sizing: border-box;
    .firstDiaCode{
      display:flex;
      color: #999999;
      border-bottom: .01rem solid #D8D8D8;
    }
    .sureBtn {
      margin:.2rem 0;
      width: 100%;
      padding:.09rem 0;
      background: #5f2689;
      text-align: center;
      border-radius: .2rem;
      color: #fff;
      font-size:.16rem;
    }
  }
  /deep/ .van-dialog__header {
    padding-top: .16rem;
    padding-bottom: .3rem;
    font-weight: 600;
  }
  /deep/ .van-cell::after {
    border: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/motor/components/motorLogin/index.vue